/**
 * assets/product-reviews.js
 * ---------------------------------------------------------------------
 * ISHVARI WEBSITE V3 — Customer Reviews
 *
 * Vanilla JS, no dependencies, no network calls, no pagination API.
 * Every review is already rendered server-side by
 * sections/product-reviews.liquid (real Liquid data, readable with JS
 * disabled) — this script only shows/hides and reorders those existing
 * DOM nodes based on the search box, rating filter, photo filter,
 * topic chips, and sort dropdown. Also wires the Write a Review toggle
 * and a small, honest, local-only "Helpful" affordance (see below).
 */
(function () {
  'use strict';

  var section = document.querySelector('.product-reviews');
  if (!section) return;

  /* -------------------------------------------------------------
     WRITE A REVIEW TOGGLE
  ------------------------------------------------------------- */
  var writeToggle = section.querySelector('[data-review-form-toggle]');
  var writeWrap = section.querySelector('[data-review-form-wrap]');
  if (writeToggle && writeWrap) {
    writeToggle.addEventListener('click', function () {
      var isHidden = writeWrap.hidden;
      writeWrap.hidden = !isHidden;
      if (isHidden) writeWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* -------------------------------------------------------------
     HELPFUL BUTTON — local-only affordance. There is no backend to
     aggregate this across visitors, so clicking it increments the
     visible count for THIS browser only and remembers that via
     localStorage (so it doesn't reset on reload and can't be clicked
     twice from the same browser). This intentionally does not claim
     to be a shared, synced count — see the section's own header
     comment for the full honest-scope reasoning.
  ------------------------------------------------------------- */
  var helpfulButtons = section.querySelectorAll('[data-review-helpful]');
  helpfulButtons.forEach(function (btn) {
    var id = btn.dataset.reviewId;
    var base = parseInt(btn.dataset.baseCount, 10) || 0;
    var storageKey = 'ishvariReviewHelpful_' + id;
    var countEl = btn.querySelector('[data-helpful-count]');
    var marked = false;

    try {
      marked = window.localStorage && localStorage.getItem(storageKey) === '1';
    } catch (e) { /* storage unavailable */ }

    function render() {
      var total = base + (marked ? 1 : 0);
      if (countEl) countEl.textContent = '(' + total + ')';
      btn.classList.toggle('is-marked', marked);
    }
    render();

    btn.addEventListener('click', function () {
      if (marked) return;
      marked = true;
      render();
      try {
        if (window.localStorage) localStorage.setItem(storageKey, '1');
      } catch (e) { /* ignore */ }
    });
  });

  /* -------------------------------------------------------------
     FILTER + SORT
  ------------------------------------------------------------- */
  var list = section.querySelector('[data-review-list]');
  if (!list) return;

  var cards = Array.prototype.slice.call(list.querySelectorAll('[data-review]'));
  var emptyMessage = section.querySelector('[data-review-empty]');

  var searchInput = section.querySelector('[data-review-search]');
  var ratingSelect = section.querySelector('[data-review-filter-rating]');
  var photosCheckbox = section.querySelector('[data-review-filter-photos]');
  var topicButtons = section.querySelectorAll('[data-review-filter-topic]');
  var sortSelect = section.querySelector('[data-review-sort]');

  var state = { search: '', rating: '0', photosOnly: false, topic: '' };

  function applyFilters() {
    var visibleCount = 0;
    cards.forEach(function (card) {
      var matchesSearch = !state.search || card.dataset.searchText.indexOf(state.search) !== -1;
      var matchesRating = state.rating === '0' || card.dataset.rating === state.rating;
      var matchesPhotos = !state.photosOnly || card.dataset.hasPhoto === 'true';
      var matchesTopic = !state.topic || (card.dataset.topics || '').indexOf(state.topic) !== -1;
      var visible = matchesSearch && matchesRating && matchesPhotos && matchesTopic;
      card.hidden = !visible;
      if (visible) visibleCount++;
    });
    if (emptyMessage) emptyMessage.hidden = visibleCount > 0;
  }

  function applySort() {
    var sortBy = sortSelect ? sortSelect.value : 'recent';
    var sorted = cards.slice().sort(function (a, b) {
      if (sortBy === 'highest') {
        return parseInt(b.dataset.rating, 10) - parseInt(a.dataset.rating, 10);
      }
      // 'recent' — ISO-ish YYYY-MM-DD strings sort correctly as plain strings
      var dateA = a.dataset.date || '';
      var dateB = b.dataset.date || '';
      return dateB.localeCompare(dateA);
    });
    sorted.forEach(function (card) { list.appendChild(card); });
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      state.search = searchInput.value.trim().toLowerCase();
      applyFilters();
    });
  }
  if (ratingSelect) {
    ratingSelect.addEventListener('change', function () {
      state.rating = ratingSelect.value;
      applyFilters();
    });
  }
  if (photosCheckbox) {
    photosCheckbox.addEventListener('change', function () {
      state.photosOnly = photosCheckbox.checked;
      applyFilters();
    });
  }
  topicButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.topic = btn.dataset.reviewFilterTopic.toLowerCase();
      topicButtons.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      applyFilters();
    });
  });
  if (sortSelect) {
    sortSelect.addEventListener('change', applySort);
  }

  applySort();
})();
